import React from 'react';
import { Container, Typography, Box, Divider, CssBaseline } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontFamily: '"League Spartan", sans-serif', // Your local font
    },
});

function About() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
                <Typography variant="h4" component="h1" gutterBottom>
                    About Us
                </Typography>
                <Divider />

                <Box mt={3}>
                    <Typography paragraph>
                        Regardless of your experience level with blockchain, Kerdos Wallet enables you to engage with the decentralized web—a new internet. Kerdos is a multi-chain self-custody cryptocurrency wallet and gateway to thousands of Web3 decentralized applications (dApps).
                    </Typography>
                    <Typography paragraph>
                        Trusted by millions globally, our mission is to ensure that this new decentralized web is accessible to everyone.
                    </Typography>
                </Box>

                <Box mt={3}>
                    <Typography paragraph>
                        Kerdos Wallet functions as both a wallet and a browser, facilitating the management of digital assets. Users can seamlessly send and spend their assets, make payments globally, and securely log into websites to engage in trading, lending, borrowing, gaming, content publishing, purchasing rare digital art, and much more.
                    </Typography>
                </Box>

                <Box mt={3}>
                    <Typography paragraph>
                        With Kerdos Wallet, your keys and assets remain under your control:
                    </Typography>
                    <Typography component="ul">
                        <li>Utilize Kerdos's secure key vault, login features, and digital wallet for effective management of your digital assets.</li>
                        <li>Generate passwords and keys directly on your mobile device to enhance account security.</li>
                        <li>Browse and connect to decentralized websites effortlessly.</li>
                        <li>Maintain control over the information you share with these sites, deciding what remains private.</li>
                    </Typography>
                </Box>

                <Box mt={3}>
                    <Typography paragraph>
                        For new users, we provide comprehensive assistance to ensure a smooth setup process. You can even import your existing wallet.
                    </Typography>
                </Box>

                <Box mt={3}>
                    <Typography variant="h6" gutterBottom>
                        Download Kerdos Wallet
                    </Typography>
                    <Typography paragraph>
                        Download the Kerdos Wallet on your mobile device and carry the decentralized web with you wherever you go.
                    </Typography>
                </Box>
            </Container>
        </ThemeProvider>
    );
}

export default About;
